export const ANALYTICAL_ACCOUNTS_LIST = "ANALYTICAL_ACCOUNTS_LIST"
export const ANALYTICAL_ACCOUNTS_LIST_SUCCESS = "ANALYTICAL_ACCOUNTS_LIST_SUCCESS"
export const ANALYTICAL_ACCOUNTS_LIST_ERROR = "ANALYTICAL_ACCOUNTS_LIST_ERROR"

export const ANALYTICAL_ACCOUNTS_NEW = "ANALYTICAL_ACCOUNTS_NEW"
export const ANALYTICAL_ACCOUNTS_NEW_SUCCESS = "ANALYTICAL_ACCOUNTS_NEW_SUCCESS"
export const ANALYTICAL_ACCOUNTS_NEW_ERROR = "ANALYTICAL_ACCOUNTS_NEW_ERROR"

export const ANALYTICAL_ACCOUNTS_EDIT = "ANALYTICAL_ACCOUNTS_EDIT"

export const ANALYTICAL_ACCOUNTS_DELETE = "ANALYTICAL_ACCOUNTS_DELETE"
export const ANALYTICAL_ACCOUNTS_DELETE_SUCCESS = "ANALYTICAL_ACCOUNTS_DELETE_SUCCESS"
export const ANALYTICAL_ACCOUNTS_DELETE_ERROR = "ANALYTICAL_ACCOUNTS_DELETE_ERROR"
